// @flow
import * as React from 'react';

import styled from 'styled-components';
import colors from '../../../assets/css/colors';

const InputItem = styled.input`
	color: ${({ is_error }) => is_error ? colors.red : colors.darkGrey};
	font-weight: bold;
	font-size: 12px;
	height: 36px;
	border: 1px solid ${({ is_error }) => is_error ? colors.red : colors.lightGrey};
	background-color: #FFFFFF;
	width: 100%;
	box-shadow: 2px 0px 9px 2px #efeeee;
	padding-left: 1em;
	
	&:disabled {
		opacity: .5;
		margin-left: 1em;
	}
	
	::placeholder {
		color: ${({ is_error }) => is_error ? colors.red : colors.darkGrey};
	}
`;

type Props = {
	placeholder: string,
	name: string,
	type: string,
	input?: Object,
	is_disabled?: boolean,
	is_error?: boolean,
	readOnly?: boolean,
};

export const Input = ({
	  name,
	  input,
	  placeholder,
	  type,
	  is_disabled,
	  is_error,
	readOnly,
}: Props ) => (
	<InputItem
		{...input}
		placeholder={placeholder}
		name={name}
		type={type}
		disabled={is_disabled}
		is_error={is_error}
		readOnly={readOnly}
	/>
);

export default Input;


// WEBPACK FOOTER //
// ./src/components/Form/Input/index.js